import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Admin.css';
import Footer from './Footer';
import { toast } from "react-toastify";


axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 403 || err.response?.status === 401) {
      toast.error("Sesija je istekla. Prijavite se ponovo.");
      localStorage.removeItem("adminToken");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("adminToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const initialFormData = {
  job_name: '',
  job_description: '',
  job_location: '',
  job_type: 'Stalni',
  available: true,
  top5: 'NE',
  salary: '',
  shortDescription: '',
  photo: null,
  // New fields:
  start_date_of_work: '',
  free_day: false,
  postedAt: '',
  number_of_working_hours: '',
  accomodation: 'NE',
  food: 'Bez obroka',
};

function Admin() {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  //const [applications, setApplications] = useState([]);
  //const [selectedRowData, setSelectedRowData] = useState(null);
  const [jobPosts, setJobPosts] = useState([]);
  const [editingJobId, setEditingJobId] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [allCities, setAllCities] = useState([]);
  const [allPositions, setAllPositions] = useState([]);
  const [partners, setPartners] = useState([]);


// Converts a data URL to a Blob.
function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

// Generates a dummy image of the specified width and height.
function generateDummyImageBlob(width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  // Fill the canvas with a white background (or any color you choose)
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, width, height);
  const dataUrl = canvas.toDataURL('image/png');
  return dataURLtoBlob(dataUrl);
}

const handleAddTestPosts = async () => {
  // Generate a dummy 800x600 image Blob.
  const dummyImageBlob = generateDummyImageBlob(800, 600);
  
  for (let i = 0; i < 20; i++) {
    const data = new FormData();
    data.append('job_name', `Test Job ${i + 1}`);
    data.append('job_description', `This is a description for test job ${i + 1}.`);
    data.append('job_location', locations[0] ? locations[0].job_location : 'Test Location');
    data.append('job_type', 'Stalni');
    data.append('available', '1');
    data.append('top5', 'NE');
    data.append('salary', '1000');
    data.append('shortDescription', `Short description for test job ${i + 1}.`);
    // Dummy values for the new fields:
    const today = new Date().toISOString().split('T')[0];
    data.append('startDate', today);
    data.append('freeDay', '0');
    data.append('postedAt', today);
    // Append the dummy 800x600 image as 'photo'
    data.append('photo', dummyImageBlob, 'dummy.png');

    try {
      await axios.post(`${API_BASE_URL}/add-job`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } catch (err) {
      console.error(`Error adding test job post ${i + 1}:`, err.response ? err.response.data : err.message);
    }
  }
  fetchJobPosts();
  toast.success('20 test job posts added!');
};










useEffect(() => {
  if (isAuthenticated) {
    axios.get(`${API_BASE_URL}/job-locations-coords`)
      .then((res) => setAllCities(res.data))
      .catch((err) => console.error('Error fetching cities:', err));

    axios.get(`${API_BASE_URL}/positions`)
      .then((res) => setAllPositions(res.data))
      .catch((err) => console.error('Error fetching positions:', err));

      axios.get(`${API_BASE_URL}/partners`)
  .then((res) => setPartners(res.data))
  .catch((err) => console.error('Error fetching partners:', err));

  }
}, [isAuthenticated]);







const handleDeleteCity = async (id) => {
  if (!window.confirm("Are you sure you want to delete this city?")) return;
  try {
    await axios.delete(`${API_BASE_URL}/delete-city/${id}`, getAuthHeaders());

    setAllCities(prev => prev.filter(city => city.id !== id));
    toast.success('Grad je uspješno obrisan!');
  } catch (err) {
    toast.error('Greška pri brisanju grada.');
    console.error(err);
  }
};

const handleDeletePosition = async (id) => {
  if (!window.confirm("Are you sure you want to delete this position?")) return;
  try {
    await axios.delete(`${API_BASE_URL}/delete-position/${id}`, getAuthHeaders());

    setAllPositions(prev => prev.filter(pos => pos.id !== id));
    toast.success('Pozicija je uspješno obrisana!');
  } catch (err) {
    toast.error('Greška pri brisanju pozicije.');
    console.error(err);
  }
};

const handleDeletePartner = async (id) => {
  if (!window.confirm("Are you sure you want to delete this partner image?")) return;

  try {
    await axios.delete(`${API_BASE_URL}/delete-partner/${id}`, getAuthHeaders());
    setPartners(prev => prev.filter(partner => partner.id !== id));
    toast.success("Partner slika obrisana!");
  } catch (err) {
    console.error('Error deleting partner:', err);
    toast.error("Greška pri brisanju partner slike.");
  }
};














  const [cityForm, setCityForm] = useState({ city_name: '', country: '' }); //NEW STUFF 04.03

  const handleCityChange = (e) => {
    const { name, value } = e.target;
    setCityForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCity = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/add-city`, cityForm, getAuthHeaders());

      toast.success(response.data);
      setCityForm({ city_name: '', country: '' });
      // Optionally refresh the list of cities if displayed
    } catch (err) {
      console.error('Error adding city:', err.response ? err.response.data : err.message);
      toast.error(err.response ? err.response.data : 'Greška pri dodavanju grada.');
    }
  };

  const [positionForm, setPositionForm] = useState({ name: '' });

// Handler for changes in the Position form
const handlePositionChange = (e) => {
  const { name, value } = e.target;
  setPositionForm((prev) => ({ ...prev, [name]: value }));
};




const handleAddPosition = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.post(`${API_BASE_URL}/add-position`, positionForm, getAuthHeaders());

    toast.success(response.data);
    setPositionForm({ name: '' });
    // Optionally refresh the list of positions if displayed
  } catch (err) {
    console.error('Error adding position:', err.response ? err.response.data : err.message);
    toast.error(err.response ? err.response.data : 'Greška pri dodavanju pozicije.');
  }
};







































  const handlePasswordChange = (e) => setPassword(e.target.value);

  const [partnerForm, setPartnerForm] = useState({ alt: '', photo: null });
  const handlePartnerChange = (e) => {
    const { name, value } = e.target;
    setPartnerForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePartnerFileChange = (e) => {
    const file = e.target.files[0];
    setPartnerForm(prev => ({ ...prev, photo: file }));
  };

  const handlePartnerSubmit = async (e) => {
    e.preventDefault();
    if (!partnerForm.photo) {
      toast.error('Molimo izaberite sliku partnera.');
      return;
    }
    const data = new FormData();
    data.append('photo', partnerForm.photo);
    data.append('alt', partnerForm.alt);
    try {
      const response = await axios.post(`${API_BASE_URL}/add-partner`, data, {
  ...getAuthHeaders(),
  headers: {
    ...getAuthHeaders().headers,
    "Content-Type": "multipart/form-data",
  },
});

      toast.success(response.data);
      setPartnerForm({ alt: '', photo: null });
    } catch (error) {
      console.error('Error adding partner image:', error.response ? error.response.data : error.message);
      toast.error('Greška pri dodavanju partnera.');
    }
  };

//   const handleLogin = async () => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/admin`, {
//       password,
//     });

//     if (response.data.success) {
//       setIsAuthenticated(true);
//       toast.success("Uspješna prijava!");
//     }
//   } catch (err) {
//     console.error("Login failed:", err);
//     toast.error("Pristup odbijen. Pogrešna lozinka.");
//   }
// };

const handleLogin = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/vilinkonjic`, { password });

    if (response.data.success) {
      localStorage.setItem("adminToken", response.data.token);
      toast.success("Uspješna prijava!");
      setIsAuthenticated(true);
    } else {
      toast.error("Pogrešna šifra!");
    }
  } catch (err) {
    toast.error("Greška pri prijavi!");
  }
};



  const getFirstSentence = (text) => {
    const sentences = text.split(/[.!?]/);
    return sentences[0] ? sentences[0] + '.' : text;
  };

  const truncate = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };
  
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/job-locations`)
      .then(response => {
        setLocations(response.data);
      })
      .catch(err => {
        console.error('Error fetching locations:', err);
        toast.error('Greška pri učitavanju lokacija.');
      });
  }, []);

  // const fetchApplications = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/applications`, getAuthHeaders());

  //     setApplications(response.data);
  //   } catch (err) {
  //     console.error('Error fetching applications:', err.message);
  //     toast.error('Greška pri učitavanju prijava.');
  //   }
  // };

  const fetchJobPosts = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/all-jobs`, getAuthHeaders());

      setJobPosts(response.data);
    } catch (err) {
      console.error('Error fetching job posts:', err.message);
      toast.error('Greška pri učitavanju oglasa.');
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      //fetchApplications();
      fetchJobPosts();
    }
  }, [isAuthenticated]);

  // When editing a job, populate the form with existing values (including the new fields)
  const handleEditJob = (job) => {
    setEditingJobId(job.id);
    setFormData({
      job_name: job.job_name,
      job_description: job.job_description,
      job_location: job.job_location,
      job_type: job.job_type || 'Stalni',
      available: job.available === 1, // assuming available is stored as 1 or 0
      top5: job.top5,
      salary: job.salary || '',
      shortDescription: job.shortDescription,
      photo: null,
      // New fields:
      start_date_of_work: job.startDate ? job.startDate.split('T')[0] : '',
      free_day: job.freeDay ? true : false,
      postedAt: job.postedAt ? job.postedAt.split('T')[0] : '',
      number_of_working_hours: job.number_of_working_hours || '',
      accomodation: job.accomodation || 'No',
      food: job.food || 'No meals',
    });
  };

  const handleDeleteJob = async (jobId) => {
    // Optional: Confirm deletion with the user
    if (!window.confirm("Are you sure you want to delete this job post?")) return;
    try {
      const response = await axios.delete(`${API_BASE_URL}/delete-job/${jobId}`, getAuthHeaders());

      toast.success(response.data);
      fetchJobPosts(); // Refresh the list of job posts after deletion
    } catch (err) {
      console.error('Error deleting job post:', err.response ? err.response.data : err.message);
      toast.error(err.response ? err.response.data : 'Greška pri brisanju oglasa.');
    }
  };
  


  // const handleRowSelect = (app) => {
  //   const rowData = [
  //     app.fullName,
  //     app.applyingForPosition,
  //     app.phoneNumber,
  //     app.extraposition || "//",
  //     new Date(app.submittedAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }),
  //     app.locationOfWork,
  //     new Date(app.startDateOfWork).toLocaleDateString('en-GB').replace(/\//g, '-'),
  //     app.emptyColumn1 || "//",
  //     app.emptyColumn2 || "//",
  //     app.salaryExpectations,
  //   ];
  //   setSelectedRowData(rowData);
  // };

  // CHANGED: New function to copy all applications at once
// const handleCopyAll = () => {
//   const allRows = applications.map(app => {
//     const row = [
//       app.fullName,
//       app.applyingForPosition,
//       app.phoneNumber,
//       app.extraposition || "//",
//       new Date(app.submittedAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' }),
//       app.locationOfWork,
//       new Date(app.startDateOfWork).toLocaleDateString('en-GB').replace(/\//g, '-'),
//       app.emptyColumn1 || "//",
//       app.emptyColumn2 || "//",
//       app.salaryExpectations,
//     ];
//     return row.join('\t');
//   });
//   const allRowsString = allRows.join('\n');
//   navigator.clipboard.writeText(allRowsString)
//     .then(() => toast.success('Sve prijave kopirane u clipboard!'))
//     .catch(err => {
//       console.error('Failed to copy all rows:', err);
//       toast.error('Greška pri kopiranju svih prijava.');
//     });
// };


  // const handleCopy = () => {
  //   if (!selectedRowData) return;
  //   const rowDataString = selectedRowData.join('\t');
  //   navigator.clipboard
  //     .writeText(rowDataString)
  //     .then(() => toast.success('Red kopiran! Zalijepite ga u Excel.'))
  //     .catch((err) => {
  //       console.error('Failed to copy row:', err);
  //       toast.error('Greška pri kopiranju reda.');
  //     });
  // };
  

const handleChange = (e) => {
  const { name, value } = e.target;

  // Default: keep value as is
  let sanitizedValue = value;

  if (name === "number_of_working_hours") {
    // Numbers only, max 2 digits
    sanitizedValue = value.replace(/\D/g, '').slice(0, 2);
} else if (name === "salary") {
  // allow "1200 - 1500", "1200–1500", keep it short
  sanitizedValue = value
    .replace(/[^0-9\-–\s]/g, '')  // digits, hyphen/en-dash, spaces
    .replace(/\s+/g, ' ')         // collapse spaces
    .trim()
    .slice(0, 30);                 // safety limit
}


  setFormData((prev) => ({ ...prev, [name]: sanitizedValue }));
};



  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) {
  //     setFormData((prev) => ({ ...prev, photo: null }));
  //     return;
  //   }
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     const img = new Image();
  //     img.onload = () => {
  //       if (img.width !== 800 || img.height !== 600) {
  //         toast.error('Dimenzije slike moraju biti 800x600.');
  //         e.target.value = null;
  //         setFormData((prev) => ({ ...prev, photo: null }));
  //         return;
  //       }
  //       setFormData((prev) => ({ ...prev, photo: file }));
  //     };
  //     img.src = event.target.result;
  //   };
  //   reader.readAsDataURL(file);
  // };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) {
    setFormData((prev) => ({ ...prev, photo: null }));
    return;
  }

  // ✅ 1. Restrict file size (max 2MB)
  if (file.size > 2 * 1024 * 1024) {
    toast.error("Slika ne može biti veća od 2MB!");
    e.target.value = null;
    setFormData((prev) => ({ ...prev, photo: null }));
    return;
  }

  // ✅ 2. Restrict file types
  const validTypes = ["image/jpeg", "image/png", "image/webp"];
  if (!validTypes.includes(file.type)) {
    toast.error("Dozvoljeni su samo JPG, PNG i WEBP formati!");
    e.target.value = null;
    setFormData((prev) => ({ ...prev, photo: null }));
    return;
  }

  // ✅ 3. Validate dimensions (must be 800x600)
  const reader = new FileReader();
  reader.onload = (event) => {
    const img = new Image();
    img.onload = () => {
      if (img.width !== 800 || img.height !== 600) {
        toast.error("Dimenzije slike moraju biti tačno 800x600!");
        e.target.value = null;
        setFormData((prev) => ({ ...prev, photo: null }));
        return;
      }

      // ✅ 4. Everything passed, accept the file
      setFormData((prev) => ({ ...prev, photo: file }));
    };
    img.src = event.target.result;
  };
  reader.readAsDataURL(file);
};


  const handleAvailabilityChange = (e) => {
    setFormData((prev) => ({ ...prev, available: e.target.value === 'true' }));
  };

  // Update the submission handlers to include the new fields.
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('job_name', formData.job_name);
    data.append('job_description', formData.job_description);
    data.append('job_location', formData.job_location);
    data.append('job_type', formData.job_type);
    data.append('available', formData.available ? '1' : '0');
    data.append('top5', formData.top5);
    data.append('salary', formData.salary);
    data.append('shortDescription', formData.shortDescription);
    // Append new fields:
    data.append('startDate', formData.start_date_of_work);
    data.append('freeDay', formData.free_day ? '1' : '0');
    data.append('postedAt', formData.postedAt);
    data.append('number_of_working_hours', formData.number_of_working_hours);
    data.append('accomodation', formData.accomodation);
    data.append('food', formData.food);

    if (formData.photo) data.append('photo', formData.photo);

    try {
      const response = await axios.post(`${API_BASE_URL}/add-job`, data, {
        ...getAuthHeaders(),
        headers: {
          ...getAuthHeaders().headers,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(response.data);
      setFormData(initialFormData);
      document.querySelector('input[name="photo"]').value = null;
      fetchJobPosts();
    } catch (err) {
      console.error('Error adding job post:', err.response ? err.response.data : err.message);
      toast.error(err.response ? err.response.data : 'Greška pri dodavanju oglasa.');
    }
  };

  const handleUpdateSubmit = async () => {
    const data = new FormData();
    data.append('job_name', formData.job_name);
    data.append('job_description', formData.job_description);
    data.append('job_location', formData.job_location);
    data.append('job_type', formData.job_type);
    data.append('available', formData.available ? '1' : '0');
    data.append('top5', formData.top5);
    data.append('salary', formData.salary);
    data.append('shortDescription', formData.shortDescription);
    // Append new fields:
    data.append('startDate', formData.start_date_of_work);
    data.append('freeDay', formData.free_day ? '1' : '0');
    data.append('postedAt', formData.postedAt);
    data.append('number_of_working_hours', formData.number_of_working_hours);
    data.append('accomodation', formData.accomodation);
    data.append('food', formData.food);

    if (formData.photo) data.append('photo', formData.photo);

    try {
     const response = await axios.post(`${API_BASE_URL}/update-job/${editingJobId}`, data, {
      ...getAuthHeaders(),
      headers: {
        ...getAuthHeaders().headers,
        "Content-Type": "multipart/form-data",
      },
    });

      toast.success(response.data);
      setFormData(initialFormData);
      setEditingJobId(null);
      document.querySelector('input[type="file"]').value = null;
      fetchJobPosts();
    } catch (err) {
      console.error('Error updating job post:', err.response ? err.response.data : err.message);
      toast.error(err.response ? err.response.data : 'Greška pri izmjeni oglasa.');
    }
  };

  

  if (!isAuthenticated) {
    return (
      <div className="admin-container">
        <div className="admin-login">
          <input
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={handlePasswordChange}
          />
          <button onClick={handleLogin}>Login</button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-page">
        <h1><i>DOBRODOSLI NA ADMIN PANEL! :)</i></h1>
        {/* <div className="copy-button-container"> */}
          {/* <button onClick={handleCopy} className="copy-button" disabled={!selectedRowData}>
            Kopiraj jedan red za Excel
          </button> */}
          {/* <button onClick={handleCopyAll} className="copy-all-button" disabled={applications.length === 0}>
    Kopiraj sve redove za Excel
  </button> */}
        {/* </div> */}
        {/* <div className="section-block">
        <h1><u>SVE PRIJAVE KANDIDATA</u></h1>
        <div className="table-container applications-scroll">
          <table className="applications-table">
            <thead>
              <tr>
                <th>Ime i prezime</th>
                <th>Pozicija</th>
                <th>Broj telefona</th>
                <th>Dodatne pozicije</th>
                <th>Vrijeme prijave (Dan / Mjesec)</th>
                <th>Lokacija</th>
                <th>Pocetak rada</th>
                <th>Prazno //</th>
                <th>Prazno //</th>
                <th>Ocekivana plata</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => (
                <tr key={app.id} onClick={() => handleRowSelect(app)}>
                  <td>{app.fullName}</td>
                  <td>{app.applyingForPosition}</td>
                  <td>{app.phoneNumber}</td>
                  <td>{app.extraposition || '//'}</td>
                  <td>
                    {new Date(app.submittedAt).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                    })}
                  </td>
                  <td>{app.locationOfWork}</td>
                  <td>
                    {new Date(app.startDateOfWork).toLocaleDateString('en-GB').replace(/\//g, '-')}
                  </td>
                  <td>{app.emptyColumn1 || '//'}</td>
                  <td>{app.emptyColumn2 || '//'}</td>
                  <td>{app.salaryExpectations}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        </div> */}
        <div className="section-block">
        <h1><u>DODAJ OGLAS</u></h1>
        <form onSubmit={handleAddSubmit} className="job-form">
        <label><b>Naslov oglasa za posao:</b></label>
          <input
            type="text"
            name="job_name"
            placeholder="Npr: Iskusan Kuvar za rad na Hvaru..."
            value={formData.job_name}
            onChange={handleChange}
          />
          <label><b>Opis oglasa za posao ( Prikazuje se po ulasku na oglas ):</b></label>
          <textarea
            name="job_description"
            placeholder="Koristi ** za Boldovan tekst. Koristi - za bullet pointe."
            value={formData.job_description}
            onChange={handleChange}
            rows="20"             
          />

          
          <label><b>Lokacija:</b></label>
          <select
            name="job_location"
            value={formData.job_location}
            onChange={handleChange}
            required
          >
            <option value="">Izaberite lokaciju</option>
            {locations.map((loc, index) => (
              <option key={index} value={loc.job_location}>
                {loc.job_location}
              </option>
            ))}
          </select>
          <label><b>Tip oglasa za posao:</b></label>
          <select name="job_type" value={formData.job_type} onChange={handleChange}>
            <option value="Stalni">Stalni</option>
            <option value="Sezonski">Sezonski</option>
          </select>
          <label><b>Dostupnost oglasa za posao:</b></label>
          <select name="available" value={formData.available} onChange={handleAvailabilityChange}>
            <option value={true}>Aktivan</option>
            <option value={false}>Nije aktivan</option>
          </select>
          <label><b>Top 6 Premium oglasa:</b></label>
          <select name="top5" value={formData.top5} onChange={handleChange}>
            <option value="DA">Da</option>
            <option value="NE">Ne</option>
          </select>
          <label><b>Plata:</b></label>
          <input
            type="text"
            name="salary"
            placeholder="Npr: 1200 – 1500"
            value={formData.salary}
            onChange={handleChange}
          />

          <label><b>Manji opis oglasa za posao ( Prikazuje se na karticama od oglasa ):</b></label>
          <textarea
            name="shortDescription"
            placeholder="Ovo je mali opis, koji ide na HomePage."
            value={formData.shortDescription}
            onChange={handleChange}
            rows="20"   
          />
          {/* New Fields for Job Post */}
          <label><b>Pocetak rada:</b></label>
          <input
            type="date"
            name="start_date_of_work"
            value={formData.start_date_of_work}
            onChange={handleChange}
            max="9999-12-31" 
          />


          <label><b>Slobodan dan:</b></label>
          <select
            name="free_day"
            value={formData.free_day ? 'DA' : 'NE'}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                free_day: e.target.value === 'DA',
              }))
            }
          >
            <option value="DA">Da</option>
            <option value="NE">Ne</option>
          </select>


          <label><b>Broj radnih sati dnevno:</b></label>

          <input
            type="text"
            name="number_of_working_hours"
            value={formData.number_of_working_hours}
            onChange={handleChange}
            placeholder="Npr: 8"
          />


              <label><b>Smjestaj:</b></label>
              <select
                name="accomodation"
                value={formData.accomodation}
                onChange={handleChange}
              >
                <option value="DA">Da</option>
                <option value="NE">Ne</option>
              </select>

              <label><b>Obroci:</b></label>
              <select
                name="food"
                value={formData.food}
                onChange={handleChange}
              >
                <option value="Bez obroka">Bez obroka</option>
                <option value="1 obrok">1 obrok</option>
                <option value="2 obroka">2 obroka</option>
                <option value="3 obroka">3 obroka</option>
              </select>


          <label><b>Datum objavljivanja oglasa:</b></label>
          <input
            type="date"
            name="postedAt"
            value={formData.postedAt}
            onChange={handleChange}
            max="9999-12-31"   
          />

          <label><b>Slika za oglas:</b></label>
          <input type="file" name="photo" accept="image/*" onChange={handleFileChange} />
          <div className="button-group">
            <button type="button" onClick={handleAddSubmit} disabled={editingJobId !== null}>
              DODAJ OGLAS
            </button>
            <button type="button" onClick={handleUpdateSubmit} disabled={editingJobId === null}>
              IZMJENI OGLAS
            </button>
          </div>
        </form>
        </div>
        
        <div className="section-block">
        <h1><u>DODAJ GRAD</u></h1>
        <form onSubmit={handleAddCity} className="city-form">
          <label><b>Ime grada:</b></label>
          <input
            type="text"
            name="city_name"
            placeholder="Npr: Budva"
            value={cityForm.city_name}
            onChange={handleCityChange}
            required
            maxLength={100}
          />

          <label><b>Drzava:</b></label>
          {/* <input
            type="text"
            name="country"
            placeholder="CRO / MNE"
            value={cityForm.country}
            onChange={handleCityChange}
            required
          /> */}
          <select
            name="country"
            value={cityForm.country}
            onChange={handleCityChange}
            required
          >
            <option value="">Izaberi drzavu</option>
            <option value="CRO">CRO</option>
            <option value="MNE">MNE</option>
          </select>
          <div className="form-button-wrapper">
          <button type="submit">DODAJ GRAD</button>
          </div>
        </form>
        </div>

        <h1><u>DODAJ POZICIJU</u></h1>
        <form onSubmit={handleAddPosition} className="position-form">
          <label><b>Ime pozicije:</b></label>
        <input
          type="text"
          name="name"
          placeholder="Npr: Domar"
          value={positionForm.name}
          onChange={handlePositionChange}
          required
          maxLength={100}
        />

          <div className="form-button-wrapper">
          <button type="submit">DODAJ POZICIJU</button>
          </div>
          </form>


        <div className="section-block">
          <h1><u>POSTOJECI GRADOVI</u></h1>
          <ul className="city-list-container">
            {[...allCities]
              .sort((a, b) => {
                // First sort by country
                if (a.country !== b.country) {
                  return a.country.localeCompare(b.country);
                }
                // If same country, then sort by city name
                return a.city_name.localeCompare(b.city_name, 'hr', { sensitivity: 'base' });
              })
              .map(city => (
                <li key={city.id}>
                  {city.city_name} ({city.country})
                  <button onClick={() => handleDeleteCity(city.id)}>Obriši</button>
                </li>
              ))}
          </ul>

        </div>

          <div className="section-block">
            <h1><u>POSTOJECE POZICIJE</u></h1>
            <ul className="position-list-container">
              {allPositions.map(pos => (
                <li key={pos.id}>
                  {pos.name}
                  <button onClick={() => handleDeletePosition(pos.id)}>Obrisi</button>
                </li>
              ))}
            </ul>
          </div>



        <div className="section-block">   
          <div className="section-block">
          <h1><u>POSTOJEĆI PARTNERI</u></h1>
          <ul className="partner-list-container">
            {partners.map(partner => (
              <li key={partner.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <img src={partner.image} alt={partner.alt} style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }} />
                <span>{partner.alt}</span>
                <button onClick={() => handleDeletePartner(partner.id)} style={{ backgroundColor: 'red', color: 'white', padding: '6px 12px', borderRadius: '4px' }}>
                  Obriši
                </button>
              </li>
            ))}
          </ul>
        </div>
            <h1><u>DODAJ SLIKU PARTNERA</u></h1>
          <form onSubmit={handlePartnerSubmit} className="partner-form">
            <input
              type="text"
              name="alt"
              placeholder="Alt text za SEO"
              value={partnerForm.alt}
              onChange={handlePartnerChange}
            />
            <input
              type="file"
              name="photo"
              accept="image/*"
              onChange={handlePartnerFileChange}
            />
            <div className="form-button-wrapper">
              <button type="submit">DODAJ PARTNERA</button>
            </div>
          </form>
        </div>




      </div>
      <div className="job-posts-container">
        
        <h1 style={{ textAlign: 'center' }}><u>POSTOJECI OGLASI ZA POSLOVE</u></h1>
        <div className="scrollable-table">
          <table className="job-posts-table">
          <thead>
          <tr>
            <th>ID</th>
            <th>Ime oglasa</th>
            <th>Opis oglasa</th>
            <th>Lokacija</th>
            <th>Tip oglasa</th>
            <th>Aktivan</th>
            <th>Top8 Poslova</th>
            <th>Plata</th>
            <th>Kratak opis</th>
            <th>Pocetak rada</th>
            <th>Slobodan dan</th>
            <th>Objavljen</th>
            <th>Radni sati</th>
            <th>Smjestaj</th>
            <th>Obroci</th>
            <th>AKCIJE</th>
          </tr>
          </thead>  
          <tbody>
  {jobPosts.map((job) => (
    <tr key={job.id}>
      <td>{job.id}</td>
      <td className="truncate" title={job.job_name}>
        {truncate(job.job_name, 100)}
      </td>

      <td className="truncate" title={job.job_description}>
      {truncate(job.job_description, 20)}
      </td>
      <td>{job.job_location}</td>
      <td>{job.job_type}</td>
      <td>{job.available === 1 || job.available === true ? 'Yes' : 'No'}</td>
      <td>{job.top5}</td>
      <td>{job.salary}</td>
      <td className="truncate" title={job.shortDescription}>
      {truncate(job.shortDescription, 20)}
      </td>
      <td>{job.startDate ? new Date(job.startDate).toLocaleDateString() : '-'}</td>
      <td>{job.freeDay ? 'DA' : 'NE'}</td>
      <td>{job.postedAt ? new Date(job.postedAt).toLocaleDateString() : '-'}</td>
      <td>{job.number_of_working_hours}</td>
      <td>{job.accomodation}</td>
      <td>{job.food}</td>
      <td>
        <button onClick={() => handleEditJob(job)}>IZMJENI</button>
        <button
          onClick={() => handleDeleteJob(job.id)}
          style={{ backgroundColor: 'red', color: 'white', marginLeft: '20px'}}
        >
          OBRISI
        </button>
      </td>
    </tr>
  ))}
</tbody>

          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Admin;
